
import {Vue, Component} from 'vue-property-decorator';
import {userApi} from "@/api/organization";
import PasswordStrength from "@/components/PasswordStrength.vue";
import baseUrl, {imageUrl} from "../../constants";
import {mechanismApi} from "../../api/organization";
import HelpTable from "@/components/HelpTable/Index.vue";
@Component({
  name: "RegistUserV2",
  components: {PasswordStrength, HelpTable}
})
export default class RegistUserV2 extends Vue {
  validateMobile = (rule: any, value: any, callback: any) => {
    if (!value) {
      return callback(new Error("请输入手机号"));
    } else {
      const mobile = this.loginData.phone;
      if(!mobile.match(/^1[3-9][0-9]{9}$/)){
        return callback(new Error('手机号格式不正确'))
      }else{
        callback();
      }
    }
  };
  validatePass = (rule: any, value: any, callback: any) => {
    const pattern = new RegExp('^(?=.*[a-zA-Z])(?=.*\\d).{8,16}$')
    if (value === '') {
      callback(new Error('请输入密码'));
    } else if (!pattern.test(value)) {
      callback(new Error('密码必须由8-16位的数字和大小写字母组成'))
    } else {
      if (this.loginData.pwd2 !== '') {
        let form = this.$refs.form as HTMLFormElement;
        form.validateField('pwd2');
      }
      callback();
    }
  };
  validatePass2 = (rule: any, value: any, callback: any) => {
    if (value === '') {
      callback(new Error('请再次输入密码'));
    } else if (value !== this.loginData.pwd) {
      callback(new Error('两次输入密码不一致!'));
    } else {
      callback();
    }
  };
  checkIdCard = (rule: any, value: any, cb: any) => {
    if (value.length == 18) {
      cb();
    } else {
      cb(new Error('清输入合法的身份证号码!'))
    }
  };

  baseUrl = baseUrl;
  imageUrl = imageUrl;
  helpVisible = false;
  active = 0;
  headers = {Authorization: ""};
  bizToken = "";
  registMsg = "";
  loginData = {
    idCard: "",
    name: "",
    pwd: "",
    pwd2: "",
    phone: "",
    token: "",
    idCardUP: "",
    idCardDown: "",
    code: "",
  };
  rules = {
    idCard: [
      {required: true, message: "请输入身份证号", trigger: "blur"},
      {validator: this.checkIdCard, trigger: 'blur'}],
    name: [{required: true, message: "请输入真实姓名", trigger: "blur"}],
    pwd: [
      {required: true, message: "请输入密码", trigger: "blur"},
      {validator: this.validatePass, trigger: 'blur'}
    ],
    pwd2: [{validator: this.validatePass2, trigger: 'blur'}],
    idCardUP: [
      {required: true, message: "请上传身份证头像面", trigger: "blur"},
    ],
    idCardDown: [
      {required: true, message: "请上传身份证国徽面", trigger: "blur"},
    ],
    phone: [
      {required: true, message: "请输入手机号", trigger: "blur"},
      {validator: this.validateMobile, trigger: "blur"}
    ],
    code: [{required: true, message: "请输入手机验证码", trigger: "blur"}],
  };
  isSend = true;
  smsInterval = "点击获取验证码";
  isSubmit = false;
  private QRCode: any;
  login(){
    console.log("123");
  }
  checkIdCardRepeat(callback: any){
    userApi.checkIdCardRepeat(this.loginData.idCard).then((r) => {
      if(r.data.result == 0){
        if(callback){
          callback();
        }
      }
    });
  }
  getIdCardInfo(callback: any){
    userApi.getIdCardInfo(this.loginData.idCardUP, "REGISTER_USER").then((r) => {
      if(r.data.result === 0){
        const {idNum, name} = r.data.data;
        this.loginData.idCard = idNum;
        this.loginData.name = name;
        if(callback){
          callback();
        }
      }
    });
  }
  detectAuth(callback: any) {
    userApi.detectAuth(this.loginData.idCard, this.loginData.name, this.loginData.idCardUP).then((r) => {
      if (r.data.result === 0) {
        const {bizToken, url} = r.data.data;
        this.bizToken = bizToken;
        if(callback){
          callback(url);
        }
      }
    });
  }
  //上传监控
  handleAvatarSuccess(res: any) {
    if (res.result === 0) {
      const rData = res.data;
      this.loginData.idCardUP = rData;
      this.$message.success("上传成功");
    }
  }

  //上传监控
  handleAvatarSuccess2(res: any) {
    if (res.result === 0) {
      const rData = res.data;
      this.loginData.idCardDown = rData;
      this.$message.success("上传成功");
    }
  }

//上传头像监控
  beforeAvatarUpload(file: any) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    if (!isJPG && !isPNG) {
      this.$message.error('上传图片只能是 JPG 或 PNG格式!');
    }
    const isLt10M = file.size / 1024 / 1024 < 10;
    if (!isLt10M) {
      this.$message.error("上传大小不能超过 10MB");
      return false;
    }
    return (isJPG || isPNG);
  }

  logout() {
    this.goLogin();
    // const win = window as any;
    // win.opener = null;
    // win.open("about:blank", "_top").close()
  }

  checkMobile() {
    //验证手机号
    if (!this.isSend) return;
    let form = this.$refs.form as HTMLFormElement;
    form.validateField('phone', (phoneError: string) => {
      if(!phoneError){
        this.isSend = true
        this.sendSms();
      }
    });
  }

  //发送手机验证码
  sendSms() {
    if (!this.isSend) return;
    this.checkIdCardRepeat(() => {
      this.isSend = false;
      this.smsInterval = "发送中...";
      mechanismApi.sendVerifyCodeUnVerify({phone: '+86' + this.loginData.phone, template: "register"}).then((r) => {
        if (r.data.result === 0) {
          this.loginData.token = r.data.data
          this.smsIntervalMethod();
        }else{
          this.smsInterval = "获取验证码";
          this.isSend = true;
        }
      });
    });
  }

  smsIntervalMethod() {
    let smsIntervalTime = 60;
    let timer = setInterval(() => {
      if (smsIntervalTime <= 1) {
        clearInterval(timer);
        this.smsInterval = "获取验证码";
        this.isSend = true; // 重新回复点击发送功能的条件
      } else {
        smsIntervalTime -= 1;
        this.smsInterval = `${smsIntervalTime}秒后再发`;
      }
    }, 1000);
  }

  prevStep() {
    this.active--;
  }

  nextStep() {
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if(valid){
        if(this.active === 0){
            this.active = 1;
        }else if(this.active === 1){
          this.getIdCardInfo(() => {
            this.active = 2;
          });
        }else if(this.active === 2){
          this.checkVerifyUI(() => {
            this.detectAuth((url: string) => {
              this.active = 3;
              this.$nextTick(() => {
                new this.QRCode(document.getElementById("mobileImg"), {
                  width: 254,
                  height: 254,
                  text: url
                });
                this.queryResult();
              });
            });
          })
        }else if(this.active === 4){
          this.getDetectInfoEnhanced(() => {
            this.active = 4;
            setTimeout(() => {
              this.$router.push("/login");
            }, 2000);
          });
        }
      }
    });
  }
  queryResult(){
    // const timer = setInterval(() => {
    //   if(this.active != 2){
    //     clearInterval(timer);
    //   }
      userApi.getDetectInfoEnhanced(this.bizToken,"USER", this.loginData.idCard, this.loginData.name, this.loginData.pwd, this.loginData.phone, this.loginData.idCardUP, this.loginData.idCardDown).then((r) => {
        const {result, data} = r.data;
        if(result === 0){
          const {text} = data;
          if(text.comparemsg === "成功"){
            this.registMsg = text.comparemsg;
            this.active = 4;
            // clearInterval(timer);
          }
        }
      });
    // }, 5000);
    // this.$once( 'hook:beforeDestroy' , () => { clearInterval(timer); });
  }

  getDetectInfoEnhanced(callback: any){
    userApi.getDetectInfoEnhanced(this.bizToken, "USER", this.loginData.idCard, this.loginData.name, this.loginData.pwd, this.loginData.phone, this.loginData.idCardUP, this.loginData.idCardDown).then((r) => {
      const {result, data, message} = r.data;
      if(result === 0){
        const {text} = data;
        this.registMsg = text.comparemsg;
        if(callback){
          callback();
        }
      }else{
        this.$message.warning(message);
        return;
      }
    });
  }

  checkVerifyUI(callback: any){
    if(!this.loginData.token){
      this.$message.warning("请先获取手机验证码！");
      return;
    }
    mechanismApi.checkVerifyUI({
      token: this.loginData.token,
      vcode: this.loginData.code
    }).then((r) => {
      if (r.data.result === 0) {
        if(callback){
          callback();
        }
      }
    });
  }

  goLogin(){
    this.$router.replace("/login");
  }

}
